module.exports = __webpack_public_path__ + "img/ab3259c.jpg";